import ApiService from '@/api/ApiService'
import proxy from '@/shared/proxy'
import User from '@/api/user/models/User'

const UserManagementService = {
  CreateUser (data: any) {
    return ApiService.putAsync(proxy.Userv2, 'User/',
      {
        ...data,
        Id: data?.UserId ?? null // Set userid if we have it from webcheckin
      })
  },
  CreateRawUser (data: any) {
    return ApiService.putAsync(proxy.Userv2, 'User/Join',
      {
        ...data
      })
  },
  DownloadAppPressed (bookingId: string, hotelId: string, startDate: any, type: string) {
    return ApiService.postAsync(proxy.Userv2, 'User/DownloadPressed', {
      BookingId: bookingId,
      HotelId: hotelId,
      StartDate: startDate,
      Type: type
    })
  },
  SkipNGetAppPressed (pmsBookingNumber: string, reservationNumber: string, hotelId: string, startDate: any, type: string) {
    return ApiService.postAsync(proxy.Userv2, 'User/SkipPressed', {
      PMSBookingNumber: pmsBookingNumber,
      ReservationNumber: reservationNumber,
      HotelId: hotelId,
      StartDate: startDate,
      Type: type
    })
  },
  CreateUserWithoutPassword (user: User) {
    return ApiService.putAsync(proxy.Userv2, 'User/WithOutPassword', user)
  },
  GetUserExistsByPhoneNumber (phoneNumber: string) {
    return ApiService.getAsync(proxy.Userv2, `User/PhoneNumber/${phoneNumber}/Exists`)
  }
}
export default UserManagementService
